export const HEADER_HEIGHT = 54;
export const DYNAMIC_GIG_CARD_CAROUSEL_HEIGHT = 400;
export const DYNAMIC_GIG_CARD_SKELETON_HEIGHT = `${DYNAMIC_GIG_CARD_CAROUSEL_HEIGHT - HEADER_HEIGHT}px`;
